const Theme = {
  body_background_color: '#F1DBAC',
  header_full_height: true,

  title_font: 'Figtree',
  title_color: '#193E44',
  subtitle_color: '#54ADAF',
  subtitleH3_color: '#FCC963',
  subtitleH3_font_weight: '600',
  text_font: 'Figtree',
  text_color: '#193E44',

  logo_image_url: 'iac.png',
  logo_height: 190,
  header_no_border: true,
  
  token_hidden: true,
  title_margin: '10px',
  
  button_color: '#54ADAF',
  button_half_border_color: '#54ADAF',
  button_radius: 10,
  button_border_width: 2,
  
  footer_background_color: '#F1DBAC',
  footer_border_color: '#F1DBAC',

  
  font_color: 'white',
}

export default Theme
// https://app.clickup.com/t/86dxg5tum